import React from 'react'
import SurveyTitle from './SurveyTitle';
import AnalyticsQuestion from './AnalyticsQuestion';

export default function AnalyticsPage({page,data}) {
    return (
        <section className="aq-page">            
            <SurveyTitle className="aq-page-header" title={page.title}></SurveyTitle>            
                <div className="survey-analytics-bar-graph-container">    
                    {page.elements.map(element=><AnalyticsQuestion key={element.name} question={element} data={data} ></AnalyticsQuestion>)}
                </div>            
        </section>
    )
}
